import React, {lazy, Suspense} from 'react'

// Lazy load components for better code splitting
// const Overview = React.lazy(() => import('../features/overview/pages'))
const Companies = React.lazy(() =>
  import('../features/companies/pages').then((module) => ({default: module.Companies}))
)
const CompanyDetails = React.lazy(() =>
  import('../features/companies/pages').then((module) => ({default: module.CompanyDetails}))
)
const CreateCompany = React.lazy(() =>
  import('../features/companies/pages').then((module) => ({default: module.CreateCompany}))
)
const Financiers = React.lazy(() =>
  import('../features/financiers/pages').then((module) => ({default: module.Financiers}))
)
const CreateFinancier = React.lazy(() =>
  import('../features/financiers/pages').then((module) => ({default: module.CreateFinancier}))
)
const FinancierDetails = React.lazy(() =>
  import('../features/financiers/pages').then((module) => ({default: module.FinancierDetails}))
)
const CreateServiceProvider = React.lazy(() =>
  import('../features/serviceProviders/pages').then((module) => ({
    default: module.CreateServiceProvider,
  }))
)
const ServiceProviderDetails = React.lazy(() =>
  import('../features/serviceProviders/pages').then((module) => ({
    default: module.ServiceProviderDetails,
  }))
)
const ServiceProviders = React.lazy(() =>
  import('../features/serviceProviders/pages').then((module) => ({
    default: module.ServiceProviders,
  }))
)
const Opportunities = React.lazy(() =>
  import('../features/calls/pages').then((module) => ({default: module.Opportunities}))
)
const DiscoverOpportunities = React.lazy(() =>
  import('../features/calls/pages').then((module) => ({default: module.DiscoverOpportunities}))
)
const CallDetails = React.lazy(() =>
  import('../features/calls/pages').then((module) => ({default: module.CallDetails}))
)
const GrantDetails = React.lazy(() =>
  import('../features/calls/pages').then((module) => ({default: module.GrantDetails}))
)
const CreateGrantOpportunity = React.lazy(() =>
  import('../features/calls/pages').then((module) => ({default: module.CreateGrantOpportunity}))
)
const Settings = React.lazy(() => import('../features/settings/pages/Settings'))
const CreateUser = React.lazy(() =>
  import('../features/settings/pages/CreateUser').then((module) => ({default: module.CreateUser}))
)
const CreateGrantProviders = React.lazy(() =>
  import('../features/developmentPartners/pages').then((module) => ({
    default: module.CreateGrantProviders,
  }))
)
const GrantProviderDetails = React.lazy(() =>
  import('../features/developmentPartners/pages').then((module) => ({
    default: module.GrantProviderDetails,
  }))
)
const GrantProviders = React.lazy(() =>
  import('../features/developmentPartners/pages').then((module) => ({
    default: module.GrantProviders,
  }))
)

// Lazy load Financier routes
const Dashboard = React.lazy(() =>
  import('../features/financiers/pages').then((module) => ({default: module.Dashboard}))
)
const FinancierPagesWrapper = React.lazy(() =>
  import('../features/financiers/pages').then((module) => ({default: module.FinancierPagesWrapper}))
)
const Calls = React.lazy(() =>
  import('../features/financiers/pages').then((module) => ({default: module.Calls}))
)
const Deals = React.lazy(() =>
  import('../features/financiers/pages').then((module) => ({default: module.Deals}))
)
const Pipeline = React.lazy(() =>
  import('../features/financiers/pages').then((module) => ({default: module.Pipeline}))
)
const CandidatesDetailPage = React.lazy(
  () => import('../features/financiers/pages/CandidatesDetailPage')
)
const CallsDetailsPage = React.lazy(() => import('../features/financiers/pages/CallsDetails'))
const FinancierCompanyDetails = React.lazy(() =>
  import('../features/financiers/components/FinancierCompanyDetails').then((module) => ({
    default: module.FinancierCompanyDetails,
  }))
)
const FinancierPortfolioDetails = React.lazy(
  () => import('../features/financiers/components/FinancierPortfolioDetails')
)
const FinancierServiceProviders = React.lazy(() =>
  import('../features/financiers/pages/FinancierServiceProviders').then((module) => ({
    default: module.FinancierServiceProviders,
  }))
)
const FinancierProfile = React.lazy(() =>
  import('../features/financiers/pages/FinancierProfile').then((module) => ({
    default: module.default,
  }))
)
const NDAReviewPage = React.lazy(
  () => import('../features/financiers/pages/NDAReviewPage')
)

// Lazy load error pages
const ErrorsPage = React.lazy(() =>
  import('../features/errors/ErrorsPage').then((module) => ({default: module.ErrorsPage}))
)

// Lazy load auth components
const Login = React.lazy(() => import('../features/auth/Login'))
const CallbackPage = React.lazy(() => import('../features/auth/CallbackPage'))
const FilePreview = React.lazy(() => import('../features/shared/pages/FilePreview'))

// Wrapper component for lazy loading
export const InboxPage = lazy(() => import('../features/correspondence/pages/InboxPage'))
export const ThreadDetailPage = lazy(() => import('../features/correspondence/pages/ThreadDetailPage'))

export const LazyComponent: React.FC<{children: React.ReactNode}> = ({children}) => (
  <Suspense fallback={null}>{children}</Suspense>
)

// Export all lazy components
export {
  // Overview,
  Companies,
  CompanyDetails,
  CreateCompany,
  Financiers,
  CreateFinancier,
  FinancierDetails,
  CreateServiceProvider,
  ServiceProviderDetails,
  ServiceProviders,
  Opportunities,
  DiscoverOpportunities,
  CallDetails,
  GrantDetails,
  CreateGrantOpportunity,
  Settings,
  CreateUser,
  CreateGrantProviders,
  GrantProviderDetails,
  GrantProviders,
  Dashboard,
  FinancierPagesWrapper,
  Calls,
  Deals,
  Pipeline,
  CandidatesDetailPage,
  CallsDetailsPage,
  FinancierCompanyDetails,
  FinancierPortfolioDetails,
  FinancierServiceProviders,
  FinancierProfile,
  NDAReviewPage,
  ErrorsPage,
  Login,
  CallbackPage,
  FilePreview,
}
